import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BzgModalRef, BzgModalService } from 'bz-genome-angular';
import { SyncFilesComponent } from '../sync-files.component';
import { SyncFilesService } from '../services/sync-files.service';

@Component({
  selector: 'biz-import-sync-files',
  templateUrl: './import-sync-files.component.html',
  styleUrls: ['./import-sync-files.component.scss']
})
export class ImportSyncFilesComponent implements OnInit {
  @ViewChild('importTemplate') importTemplate: TemplateRef<any>;
  
  private modalComponentRef: BzgModalRef;
  importHistory: any;

  constructor(private _modalService: BzgModalService,
    private _syncFileService: SyncFilesService) { }

  ngOnInit() {
    this.getImportHistory();
  }

  onImport() {
    this.modalComponentRef = this._modalService.open(this.importTemplate, {
      closeOnBackdropClick: false, maxWidth: '1000px', closeOnRouterNavigation: true
    });
  }
  
  public closeModal() {
    this.getImportHistory();
    this.modalComponentRef.close();
  }

  private getImportHistory() {
    this._syncFileService.getImportHistory().then(data => {
      this.OrderHistory(data);
      this.importHistory = data.map(item => {
        let showDetail;
        try {
          JSON.parse(item.errorLog);
          showDetail = true;
        } catch (error) {
          showDetail = false;
        }

        return {
          ...item,
          showDetail: showDetail,
          detailExpanded: false
        };
      });
      
    });
  }

  private OrderHistory(data: any) {
    return data.sort((a, b) => {
      return new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime();
    });
  }
}
